import { MutationTree } from "vuex";
import { RootState } from "./types";

export const mutations: MutationTree<RootState> = {
  mutationLocale(state, payload: string) {
    state.locale = payload;
  },
  mutationColor(state, payload: number) {
    if (typeof payload === "number") {
      state.theme_color = payload;
    } else {
      state.theme_color = 1;
    }
  },
};
